import { Stack } from '@mui/material';
import { ControlledSelectInput2 } from 'Components';
import { AdvancedSearchContext } from 'Context/MedicalReferralsContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { useContext } from 'react';

export const YearRange = () => {
  const { advancedSearch, dispatchAdvancedSearch } = useContext(
    AdvancedSearchContext
  );
  const isDesktop = useIsDesktop();

  const yearRange: string[] = [];
  for (
    let year = advancedSearch.dateMinMaxRange.min.getFullYear();
    year <= advancedSearch.dateMinMaxRange.max.getFullYear();
    year++
  )
    yearRange.push(year.toString());

  return (
    <Stack>
      <ControlledSelectInput2
        size={'small'}
        disablePortal={isDesktop ? false : true}
        label={
          Dictionary[DICTIONARY.MedicalReferrals].search.advancedSearch.year
        }
        value={advancedSearch.dateRange.start?.getFullYear().toString() || ''}
        options={[...yearRange]}
        onChange={(e) => {
          dispatchAdvancedSearch({
            type: 'REQUEST_DATE_RANGE',
            payload: {
              value: {
                start: new Date(Number(e.target.value), 0, 1),
                end: new Date(Number(e.target.value), 11, 31),
                isYear: true,
              },
            },
          });
        }}
      />
    </Stack>
  );
};
